import React, { FC } from "react";
import { Link } from "../../AVCore/Link";
import * as AV from "../../AVCore/AVCore";
import { Box } from "native-base";
import { renderToStaticMarkup } from "react-dom/server"; // Converts JSX to static markup

// Import SVG components
import {
  CreateClass,
  CreateCommunity,
  CreateElite,
  CreateGraduation,
  CreateGroup,
  CreateNeighborhood,
  CreateOrganization,
  CreateSchool,
  CreateTeam,
  CreatePerformanceGroup,
  CreateClub,
  HuddleAvatarIcon,
  Event,
  Profile,
  PetIcon,
} from "../../assets/icons/icon-assets";

interface Props {
  width: any;
  height: any;
  link: AV.ILink & { subtype?: string };
}

const EntityProfilePic: FC<Props> = ({ width, height, link }) => {
  let uri = Link.getTummb(link);

  if (link?.id === AV.Person.self()?.id) {
    let selfLink = AV.Person.getLink(AV.Person.self());
    uri = Link.getTummb(selfLink);
  }

  // Convert an SVG component to a Base64 URL
  const convertSvgToDataUrl = (svgElement: JSX.Element) => {
    const svgMarkup = renderToStaticMarkup(svgElement);
    return `data:image/svg+xml;base64,${btoa(
      unescape(encodeURIComponent(svgMarkup)),
    )}`;
  };

  // Get the correct icon as a Base64 data URL
  const getDefaultIconSrc = () => {
    if (
      (link?.type === "Team" && link?.subType !== "Club") ||
      (link?.type === "PlayerOrg" && link?.subType === undefined)
    ) {
      return convertSvgToDataUrl(
        <CreateTeam height={25} width={25} color={"#32AE78"} />,
      );
    } else if (link?.type === "Club") {
      return convertSvgToDataUrl(
        <CreateElite height={20} width={20} color={"#32AE78"} />,
      );
    } else if (
      link?.type === "School" ||
      link?.type === "SchoolYear" ||
      link?.subType === "Alumni"
    ) {
      return convertSvgToDataUrl(
        <CreateSchool height={20} width={20} color={"#32AE78"} />,
      );
    } else if (link?.type === "Group") {
      return convertSvgToDataUrl(
        <CreateGroup height={20} width={20} color={"#32AE78"} />,
      );
    } else if (link?.subType === "Class") {
      return convertSvgToDataUrl(
        <CreateClass height={20} width={20} color={"#32AE78"} />,
      );
    } else if (link?.subType === "GradClass") {
      return convertSvgToDataUrl(
        <CreateGraduation height={20} width={20} color={"#32AE78"} />,
      );
    } else if (link?.type === "Organization") {
      return convertSvgToDataUrl(
        <CreateOrganization height={20} width={20} color={"#32AE78"} />,
      );
    } else if (link?.type === "Neighborhood") {
      return convertSvgToDataUrl(
        <CreateNeighborhood height={20} width={20} color={"#32AE78"} />,
      );
    } else if (link?.type === "Community") {
      return convertSvgToDataUrl(
        <CreateCommunity height={20} width={20} color={"#32AE78"} />,
      );
    } else if (link?.subType === "Club" || link?.subType === "Term") {
      return convertSvgToDataUrl(
        <CreateClub height={20} width={20} color={"#32AE78"} />,
      );
    } else if (link?.type === "Channel") {
      return convertSvgToDataUrl(<HuddleAvatarIcon height={20} width={20} />);
    } else if (link?.subType === "MusicGroup") {
      return convertSvgToDataUrl(
        <CreatePerformanceGroup height={20} width={20} />,
      );
    } else if (link?.type === "Event") {
      return convertSvgToDataUrl(
        <Event height={20} width={20} color={"#32AE78"} />,
      );
    } else if (link?.type === "Person") {
      return convertSvgToDataUrl(
        <Profile height={20} width={20} color={"#32AE78"} />,
      );
    } else if (link?.type === "Pet") {
      return convertSvgToDataUrl(
        <PetIcon height={20} width={20} color={"#32AE78"} />,
      );
    } else {
      return convertSvgToDataUrl(
        <CreateTeam height={20} width={20} color={"#32AE78"} />,
      );
    }
  };

  return (
    <Box
      width={width}
      height={height}
      alignItems="center"
      justifyContent="center"
    >
      {uri ? (
        <img
          src={uri}
          alt="Entity Profile Picture"
          style={{ width: "100%", height: "100%" /*borderRadius: "50%"*/ }}
        />
      ) : (
        <img
          src={getDefaultIconSrc()}
          alt="Default Entity Icon"
          style={{
            width:
              link?.type === "Person" || link?.type === "Pet" ? "100%" : "65%",
            height:
              link?.type === "Person" || link?.type === "Pet"
                ? "100%"
                : "75%" /*borderRadius: "50%"*/,
          }}
        />
      )}
    </Box>
  );
};

export default EntityProfilePic;
